import React from "react";
import { Link } from "react-router-dom";
import { PawPrint } from "lucide-react";

/**
 * Brand glyph used in cabinet auth flows. Always renders as a Link to "/"
 * so clicking the logo returns the visitor to the public home page.
 */
export default function BrandMark({ size = "md", to = "/" }) {
  const sizes = {
    sm: { wrap: "h-8", icon: "h-4 w-4", text: "text-sm" },
    md: { wrap: "h-9", icon: "h-4 w-4", text: "text-base" },
    lg: { wrap: "h-10", icon: "h-5 w-5", text: "text-lg" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <Link
      to={to}
      data-testid="brand-mark"
      className={`inline-flex items-center gap-2 ${s.wrap} transition-opacity hover:opacity-80 focus-visible:opacity-80 focus-visible:outline-none`}
      aria-label="SmartPaw — home"
    >
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]">
        <PawPrint className={s.icon} />
      </span>
      <span className={`font-serif font-semibold tracking-tight ${s.text}`}>SmartPaw</span>
    </Link>
  );
}
